








import { getMessages, IMessage } from '@/store/messages'

import { IUser } from 'src/laura-types'
import { getCurrentUser } from '@ultraware/vue-user-management'
import Messages from 'src/components/Messages.vue'
import Welcome from 'src/components/Welcome.vue'
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { IVxsPromise, vxsActionFetch, vxsDataGetter } from 'vuex-xhr-state'

@Component({
  components: { Messages, Welcome },
})
export default class Home extends Vue {
  @vxsDataGetter(getMessages) public getMessages!: () => IMessage[]
  @vxsActionFetch(getMessages) public fetchMessages!: () => IVxsPromise<IMessage[]>
  @Getter(getCurrentUser) public user!: IUser

  get messages(): IMessage[] {
    return this.getMessages()
  }

  public created(): void {
    this.fetchMessages()
  }
}
